import { AccessTokenApiModel } from '../../../types/models/access-token.model';
import { AuthenticateApiRequest } from '../../../types/requests/authentication/authenticate.request';
import { PasswordResetApiRequest } from '../../../types/requests/authentication/password-reset.request';
import { RecoverPasswordApiRequest } from '../../../types/requests/authentication/recover-password.request';
import { RefreshTokenApiRequest } from '../../../types/requests/authentication/refresh-token.request';
import { ValidatePasswordResetTokenApiRequest } from '../../../types/requests/authentication/validate-password-reset-token.request';
import { client } from './client';

export const authenticate = (params: AuthenticateApiRequest) =>
  client.post<AccessTokenApiModel>('/authentication', params);

export const refreshToken = (params: RefreshTokenApiRequest) =>
  client.post<AccessTokenApiModel>('/authentication/token', params);

export const recoverPassword = (params: RecoverPasswordApiRequest) =>
  client.post<void>('/authentication/recover-password', params);

export const validatePasswordResetToken = (params: ValidatePasswordResetTokenApiRequest) =>
  client.get<void>('/authentication/password-reset', { params });

export const passwordReset = (params: PasswordResetApiRequest) =>
  client.post<void>('/authentication/password-reset', params);
